import { render, staticRenderFns } from "./TimezoneTests.vue?vue&type=template&id=8c9fda92&"
import script from "./TimezoneTests.vue?vue&type=script&lang=js&"
export * from "./TimezoneTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports